import { render, staticRenderFns } from "./ProjectIndex.vue?vue&type=template&id=a80a07c6&scoped=true"
import script from "./ProjectIndex.vue?vue&type=script&lang=js"
export * from "./ProjectIndex.vue?vue&type=script&lang=js"
import style0 from "./ProjectIndex.vue?vue&type=style&index=0&id=a80a07c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80a07c6",
  null
  
)

export default component.exports